import { FunctionComponent, useLayoutEffect } from 'react';
import styled from '@emotion/styled';
import { useHtmlLang } from '@ds/react-utils';
import { ContainerLayoutCover, ContainerLayoutHeader, ContainerLayoutInnerContent, ContainerLayoutFooter } from './components';
import { breakpoints } from '@ds/ui';
import breakpointSizes from 'layouts/ApplicationLayout/objects/breakpointSizes/breakpointSizes';
import { CoverImageConstants } from 'layouts/constants';
import { inkSpacingTokens } from '@ds/tokens';

type ContainerLayoutType = {
    Cover: typeof ContainerLayoutCover;
    Header: typeof ContainerLayoutHeader;
    Footer: typeof ContainerLayoutFooter;
    InnerContent: typeof ContainerLayoutInnerContent;
} & FunctionComponent<{ className?: string }>;

const ContainerLayoutContainer = styled.div`
    height: 100%;
    position: relative;

    &.has-cover-image {
        ${breakpoints.lessThan(breakpointSizes.xs)} {
            height: calc(100% - ${CoverImageConstants.heightMobile});
        }
        ${breakpoints.greaterThan(breakpointSizes.xs)} {
            height: calc(100% - ${CoverImageConstants.heightDesktop});
        }
    }

    /* flexible containerLayoutFooter for mobile */
    ${breakpoints.lessThan(breakpointSizes.xs)} {
        display: flex;
        flex-direction: column;
    }

    // XXXS - (MOBILE)
    margin: 0 ${inkSpacingTokens.spacingM};
    // XXS - (MOBILE)
    ${breakpoints.greaterThan(breakpointSizes.xxxs)} {
        margin: 0 ${inkSpacingTokens.spacingL};
    }
    // XS - (MOBILE)
    ${breakpoints.greaterThan(breakpointSizes.xxs)} {
        margin: 0 ${inkSpacingTokens.spacingXXL};
    }
    // S - (DESKTOP)
    ${breakpoints.greaterThan(breakpointSizes.xs)} {
        margin: auto;
        width: 580px;
    }
    // M, L, XL...  - (DESKTOP)
    ${breakpoints.greaterThan(breakpointSizes.s)} {
        width: 800px;
    }
`;

const ContainerLayout: ContainerLayoutType = props => {
    const currentLocale = useHtmlLang();

    useLayoutEffect(() => {
        document.querySelector<HTMLElement>('[tabIndex="-1"]')?.focus();
    }, [currentLocale]);

    return <ContainerLayoutContainer {...props} />;
};

ContainerLayout.Cover = ContainerLayoutCover;
ContainerLayout.Header = ContainerLayoutHeader;
ContainerLayout.Footer = ContainerLayoutFooter;
ContainerLayout.InnerContent = ContainerLayoutInnerContent;

export default ContainerLayout;
